import React from 'react';
import {useCurrencyFormatter} from '../../../../../../../hooks/useCurrencyFormatter';
import {classes, st} from './TotalPrice.st.css';
import {ProductLineItemDataHook} from '../../ProductLineItemBase';
import {Item} from '../../../../../../../types/app.types';
import {useOrderDiscounts} from '../../../../hooks/useOrderDiscounts';
import {calculateTotal} from './calculateTotal';

export interface TotalPriceProps {
  lineItem: Item;
  className?: string;
}

export const CompareTotalPrice = ({lineItem, className}: TotalPriceProps) => {
  const formatCurrency = useCurrencyFormatter();
  const {lineItemDiscounts} = useOrderDiscounts();

  const discountsExist = !!(lineItem?.id && lineItemDiscounts[lineItem.id]?.length);
  if (!discountsExist) {
    return null;
  }

  const totalBeforeDiscount = calculateTotal(lineItem?.priceBeforeDiscounts?.amount, lineItem?.quantity);
  if (!totalBeforeDiscount) {
    return null;
  }

  return (
    <del data-hook={ProductLineItemDataHook.CompareTotalPrice} className={st(classes.compareTotalPrice, className)}>
      {formatCurrency(totalBeforeDiscount)}
    </del>
  );
};
